import store from '@/store';

import { checkUserValidity } from './checkUserValidity';
import { getUUID } from './getUuid';
import { notAuthHandler } from './notAuthHandler';
import { p2pSendSuccessHandler } from './p2pSendSuccessHandler';
import { responseCredentials } from './responseCredentials';
import { sendCredentials } from './sendCredentials';

export const inMsgHandler = async (dataRec, source: string) => {
    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;
    const uuids = await getUUID();

    if (isInUploadKeyPage && dataRec?.client_event === 'not_auth') {
        notAuthHandler(uuids[0].uuid, false, dataRec?.rejected ? true : false);
    } else if (
        isInUploadKeyPage &&
        dataRec?.client_event === 'send_credentials'
    ) {
        responseCredentials(dataRec);
    } else if (
        !isInUploadKeyPage &&
        dataRec?.client_event === 'init_auth' &&
        source
    ) {
        sendCredentials(dataRec, source);
    } else if (!isInUploadKeyPage && dataRec?.client_event === 'validate_me') {
        checkUserValidity(dataRec, source);
    } else if (isInUploadKeyPage && dataRec?.client_event === 'sent_keys') {
        p2pSendSuccessHandler(dataRec);
    }
};
